export const BUILD_INFO = { sha: 'c8fab57' };
